/**
 * 滚动位置管理器 - 单一职责：管理滚动位置重置逻辑
 */
class SaScrollPositionManager {
    constructor() {
      this._isBackNavigation = false;
      this._beforeUnloadHandler = null;
      this._popStateHandler = null;
    }
  
    /**
     * 初始化滚动位置管理
     */
    init() {
      this._isBackNavigation = false;
      this.setupEventListeners();
    }
  
    /**
     * 检查是否是返回导航
     */
    isBackNavigation() {
      return this._isBackNavigation;
    }
  
    /**
     * 重置滚动位置到顶部
     */
    reset() {
      // 检查是否是返回操作
      if (this._isBackNavigation) {
        this._isBackNavigation = false;
        return;
      }
      
      window.scrollTo(0, 0);
      if (document.documentElement) {
        document.documentElement.scrollTop = 0;
      }
      if (document.body) {
        document.body.scrollTop = 0;
      }
    }
  
    /**
     * 设置事件监听器
     */
    setupEventListeners() {
      this._beforeUnloadHandler = () => {
        if (this.isReload()) {
          this.reset();
        }
      };
      window.addEventListener('beforeunload', this._beforeUnloadHandler);
  
      this._popStateHandler = () => {
        this._isBackNavigation = true;
      };
      window.addEventListener('popstate', this._popStateHandler);
    }
  
    /**
     * 清理事件监听器
     */
    destroy() {
      if (this._beforeUnloadHandler) {
        window.removeEventListener('beforeunload', this._beforeUnloadHandler);
      }
      if (this._popStateHandler) {
        window.removeEventListener('popstate', this._popStateHandler);
      }
    }
  
    /**
     * 检测是否是刷新操作
     */
    isReload() {
      if (window.performance && window.performance.navigation) {
        return window.performance.navigation.type === 1;
      }
      
      if (window.performance && window.performance.getEntriesByType) {
        const navigationEntries = window.performance.getEntriesByType('navigation');
        if (navigationEntries.length > 0) {
          return navigationEntries[0].type === 'reload';
        }
      }
      
      return false;
    }
  }
let saScrollPositionManager = null;
function initSaScrollPositionManager() {
    if (saScrollPositionManager) {
        return;
    }
    saScrollPositionManager = new SaScrollPositionManager();
    saScrollPositionManager.init();
    saScrollPositionManager.reset();
}
if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
        initSaScrollPositionManager();
    });
} else {
    window.onload = () => {
        window.setTimeout(initSaScrollPositionManager, 700);
    };
}